import { render, staticRenderFns } from "./DnsSslIndicator.vue?vue&type=template&id=cb39aca4&scoped=true"
import script from "./DnsSslIndicator.vue?vue&type=script&lang=js"
export * from "./DnsSslIndicator.vue?vue&type=script&lang=js"
import style0 from "./DnsSslIndicator.vue?vue&type=style&index=0&id=cb39aca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb39aca4",
  null
  
)

export default component.exports